(function ()
{
    'use strict';

    angular
        .module('app.custom')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/tarefas');

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true
            });
    }

})();
